import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class ActiveIngredients extends UcoastEl {
	static htmlSelector = 'active-ingredients'

	private triggers: HTMLButtonElement[]
	private panels: HTMLElement[]
	private activeIndex = 0

	constructor() {
		super()

		this.triggers = Array.from(
			this.querySelectorAll<HTMLButtonElement>(
				'[data-active-ingredients-trigger]'
			)
		)
		this.panels = Array.from(
			this.querySelectorAll<HTMLElement>('[data-active-ingredients-panel]')
		)
	}

	override connectedCallback() {
		super.connectedCallback()

		if (!this.triggers.length || !this.panels.length) return

		this.triggers.forEach((trigger) =>
			trigger.addEventListener('click', this.handleTriggerClick)
		)

		this.activate(0)
	}

	override disconnectedCallback() {
		super.disconnectedCallback()

		this.triggers.forEach((trigger) =>
			trigger.removeEventListener('click', this.handleTriggerClick)
		)
	}

	private handleTriggerClick = (event: MouseEvent) => {
		const trigger = q.oct<MouseEvent, HTMLButtonElement>(event)
		if (!trigger) return

		const index = Number(trigger.dataset.ingredientIndex)
		if (Number.isNaN(index)) return

		this.activate(index)
	}

	private activate(index: number) {
		this.activeIndex = index

		this.triggers.forEach((trigger, triggerIndex) => {
			const isActive = triggerIndex === index
			trigger.classList.toggle('is-active', isActive)
			trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false')
		})

		this.panels.forEach((panel) => {
			const panelIndex = Number(panel.dataset.ingredientIndex)
			const isActive = panelIndex === index
			panel.classList.toggle('is-active', isActive)
			panel.hidden = !isActive
		})
	}
}
